import React, { useEffect, useState } from "react";
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner";
import Navbar from "../components/Navbar.js";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";







export default function AccountType(props) {

  const { t, i18n } = useTranslation()
  const { isAuth } = useSelector((state) => state.auth);

  const plans = [
    {
      id: "silver",
      title: t("SILVER_ACCOUNT"),
      price: "£ 10,000",
      features: [
        t("MINI_DEP"),
        t("INCLUDES"),
        t("FOREX_LEVERAGE", { leverage: "1:100" }),
        t("STOCKS_LEVERAGE", { leverage: "1:1" }),
        t("CRYPTO_CURRENCIES"),
        t("COMMODITIES"),
        t("INDICES"),
        t("SAVING_ACCOUNT"),
        t("DAILY_NEWS"),
        t("WEEKLY_MARKET_VIEW"),
        t("ACCOUNT_MANAGER"),
        t("WEEKLY_PORFOLIO")
      ],
      btnText: t("SELECT_SILVER")
    },
    {
      id: "gold",
      title: t("GOLD_ACCOUNT"),
      price: "£ 50,000",
      features: [
        t("MINI_DEP"),
        t("INCLUDES"),
        t("FOREX_LEVERAGE", { leverage: "1:200" }),
        t("STOCKS_LEVERAGE", { leverage: "1:2" }),
        t("CRYPTO_CURRENCIES"),
        t("COMMODITIES"),
        t("INDICES"),
        t("SAVING_ACCOUNT"),
        t("MARGIN_LOAN", { percentage: "25%" }),
        t("INVITATION"),
        t("DAILY_MARKET_VIEW"),
        t('DAILY_POR'),
        t("SILVER_DESCRIPTION2"),
        t("MONTHLY_SESSION"),
        t("24_HOUR")
      ],
      btnText: t("SELECT_GOLD")
    },
    {
      id: "platinum",
      title: t("PLATINUM_ACCOUNT"),
      price: "£ 100,000",
      features: [
        t("MINI_DEP"),
        t("INCLUDES"),
        t("FOREX_LEVERAGE", { leverage: "1:200" }),
        t("STOCKS_LEVERAGE", { leverage: "1:2" }),
        t("CRYPTO_CURRENCIES"),
        t("COMMODITIES"),
        t("INDICES"),
        t("SAVING_ACCOUNT"),
        t("MARGIN_LOAN", { percentage: "50%" }),
        t("ACCESS_TRADING_EVENTS"),
        t("DAILY_MARKET_VIEW"),
        t('DAILY_POR'),
        t("PERSONAL_PORFOLIO"),
        t("WEEKLY_WEBINAR"),
        t("WEEKLY_ANALYST"),
        t("MONTHLY_SESSION"),
        t("24_HOUR")
      ],
      btnText: t("SELECT_PLATINUM")
    },
    {
      id: "diamond",
      title: t("DIAMOND_ACCOUNT"),
      price: "£ 250,000",
      features: [
        t("MINI_DEP"),
        t("INCLUDES"),
        t("FOREX_LEVERAGE", { leverage: "1:300" }),
        t("STOCKS_LEVERAGE", { leverage: "1:4" }),
        t("CRYPTO_CURRENCIES"),
        t("COMMODITIES"),
        t("INDICES"),
        t("SAVING_ACCOUNT"),
        t("MARGIN_LOAN", { percentage: "75%" }),
        t("ACCESS_TRADING_EVENTS"),
        t("DAILY_MARKET_VIEW"),
        t('DAILY_POR'),
        t("PERSONAL_PORFOLIO"),
        t("WEEKLY_WEBINAR"),
        t("DAILY_ANALYST"),
        t("CUSTOMIZED_EDUCATION"),
        t("DAILY_MARKET"),
        t("RESEARCH"),
        t("INVITES_VIP")
      ],
      btnText: t("SELECT_DIAMOND")
    },
    {
      id: "corporate",
      title: t("CORPORATE_ACCOUNT"),
      price: "£ 1,000,000",
      features: [
        t("MINI_DEP"),
        t("INCLUDES"),
        t("FOREX_LEVERAGE", { leverage: "1:400" }),
        t("STOCKS_LEVERAGE", { leverage: "1:5" }),
        t("CRYPTO_CURRENCIES"),
        t("COMMODITIES"),
        t("INDICES"),
        t("SAVING_ACCOUNT"),
        t("MARGIN_LOAN", { percentage: "100%" }),
        t("ACCESS_TRADING_EVENTS"),
        t("DAILY_REVIEW"),
        t("UNLIMITED_ACCESS"),
        t("PERSONAL_CHIEF"),
        t("CUSTOMIZED_EDUCATION"),
        t("DAILY_ONE"),
        t("WEALTH_MANAGER"),
        t("INVITES_VIP")
      ],
      btnText: t("SELECT_CORPORATE")
    }
  ];

  const [activeTab, setActiveTab] = useState(plans[0].id);
  const activePlan = plans.find((p) => p.id === activeTab);

  return (
    <div>
      {isAuth ? <NavbarInner /> : <Navbar />}
      <div className="innerpages_wrapper">
        <div className="container">
          <div className="inner_title_wrapper account_type">
            <h2 className="inner_title">{t("ACCOUNT_TYPES")}</h2>
          </div>
          <div className="dash_wrapper account_type_wrapper">
            <div className="row">
              <div className="col-xl-12">
                
                <div 
                  className="account-tabs-container" 
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                    marginBottom: "40px",
                    padding: "0 15px"
                  }}
                >
                  {plans.map((plan) => (
                    <button
                      key={plan.id}
                      onClick={() => setActiveTab(plan.id)}
                      style={{
                        position: "relative",
                        padding: "12px 24px",
                        fontSize: "16px",
                        fontWeight: "600",
                        borderRadius: "50px",
                        border: "none",
                        background: "transparent",
                        color: activeTab === plan.id ? "#fff" : "var(--text-color, #777)",
                        cursor: "pointer",
                        outline: "none",
                        transition: "color 0.3s ease",
                        zIndex: 1
                      }}
                    >
                      {activeTab === plan.id && (
                        <motion.div
                          layoutId="activeTabIndicator"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "#395645",
                            borderRadius: "50px",
                            zIndex: -1,
                            boxShadow: "rgba(57, 86, 69, 0.2) 0px 4px 12px"
                          }}
                          transition={{ type: "spring", stiffness: 300, damping: 30 }}
                        />
                      )}
                      {plan.title}
                    </button>
                  ))}
                </div>

                <div className="snip1517" style={{ display: 'flex', justifyContent: 'center' }}>
                  <AnimatePresence mode="wait">
                    {activePlan && (
                      <motion.div
                        key={activePlan.id}
                        initial={{ opacity: 0, y: 30, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -30, scale: 0.95 }}
                        transition={{ duration: 0.4, ease: "easeOut" }}
                        className="plan"
                        style={{ maxWidth: "500px", width: "100%", margin: "0 auto" }}
                      >
                        <div>
                          <header>
                            <h4 className="plan-title">{activePlan.title}</h4>
                            <div className="plan-cost">
                              <span className="plan-price">{activePlan.price}</span>
                            </div>
                          </header>
                          <ul className="plan-features">
                            {activePlan.features.map((feature, idx) => (
                              <motion.li 
                                key={idx}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.3, delay: idx * 0.05 }}
                                style={{ display: "flex", alignItems: "center", textAlign: "left" }}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#395645" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "10px", flexShrink: 0 }}>
                                  <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                <span>{feature}</span>
                              </motion.li>
                            ))}
                          </ul>
                        </div>
                        <div className="plan-select">
                          <a href="#" className="primary_btn">
                            {activePlan.btnText}
                          </a>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterNew />
    </div>
  );
}
